/* MMI Theme JS v3 — Magallon Made Innovations */
document.addEventListener('DOMContentLoaded', () => {
  mmiInitCart();
  mmiInitNav();
  mmiInitProductPage();
  mmiInitScrollReveal();
});

function mmiInitCart() {
  const drawer  = document.getElementById('mmi-cart-drawer');
  const overlay = document.getElementById('mmi-overlay');
  const closeBtn = document.getElementById('mmi-cart-close');
  if (!drawer) return;
  function openCart()  { drawer.classList.add('open');  overlay?.classList.add('on');  document.body.style.overflow='hidden'; }
  function closeCart() { drawer.classList.remove('open'); overlay?.classList.remove('on'); document.body.style.overflow=''; }
  document.querySelectorAll('[data-mmi-cart-open]').forEach(b => b.addEventListener('click', openCart));
  closeBtn?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  window.mmiOpenCart  = openCart;
  window.mmiCloseCart = closeCart;
}

async function mmiUpdateCartCount() {
  try {
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('.mmi-cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch(e) {}
}

async function mmiAddToCart(variantId, qty) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify({id: variantId, quantity: qty || 1})
    });
    if (res.ok) { mmiUpdateCartCount(); window.mmiOpenCart?.(); }
  } catch(e) { console.error(e); }
}

function mmiInitNav() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav    = document.querySelector('.nav-primary');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('mobile-open');
    document.body.style.overflow = open ? 'hidden' : '';
  });
}

function mmiInitProductPage() {
  // Tabs
  document.querySelectorAll('.tab-button').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.dataset.panel;
      btn.closest('.tab-nav').querySelectorAll('.tab-button').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(panel)?.classList.add('active');
    });
  });
  // Qty
  document.querySelectorAll('.qty-input').forEach(wrap => {
    wrap.querySelector('.qty-dec')?.addEventListener('click', () => {
      const n = wrap.querySelector('.qty-num'); if(n) n.value = Math.max(1, parseInt(n.value||1)-1);
    });
    wrap.querySelector('.qty-inc')?.addEventListener('click', () => {
      const n = wrap.querySelector('.qty-num'); if(n) n.value = Math.min(99, parseInt(n.value||1)+1);
    });
  });
  // Option swatches
  document.querySelectorAll('.option-swatches').forEach(group => {
    group.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        const lbl = btn.closest('.option-group')?.querySelector('.option-current');
        if (lbl) lbl.textContent = btn.dataset.value;
        mmiMatchVariant();
      });
    });
  });
  // ATC form
  document.getElementById('mmi-product-form')?.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = document.getElementById('mmi-atc-btn');
    const id  = document.getElementById('mmi-variant-id')?.value;
    const qty = parseInt(document.getElementById('mmi-qty')?.value || 1);
    const orig = btn.innerHTML;
    btn.innerHTML = 'Adding...'; btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({id, quantity: qty})
      });
      if (res.ok) {
        btn.innerHTML = '✓ Added!'; btn.style.background = '#2d7a47';
        mmiUpdateCartCount();
        setTimeout(() => { btn.innerHTML=orig; btn.style.background=''; btn.disabled=false; window.mmiOpenCart?.(); }, 1600);
      } else { btn.innerHTML = orig; btn.disabled = false; }
    } catch(e) { btn.innerHTML = orig; btn.disabled = false; }
  });
  // Thumbnail switching
  document.querySelectorAll('.product-thumb').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const img = document.getElementById('mmi-main-img');
      const src = t.dataset.full;
      if (img && src) img.src = src;
    });
  });
}

function mmiMatchVariant() {
  if (!window.mmiVariants) return;
  const selected = [...document.querySelectorAll('.option-btn.selected')].map(b => b.dataset.value);
  const match = window.mmiVariants.find(v =>
    [v.option1,v.option2,v.option3].filter(Boolean).every((o,i) => !selected[i] || selected[i]===o)
  );
  if (!match) return;
  const vid = document.getElementById('mmi-variant-id'); if(vid) vid.value = match.id;
  const pEl = document.querySelector('.product-price');
  if (pEl) pEl.textContent = '$' + (match.price/100).toFixed(2);
  const btn = document.getElementById('mmi-atc-btn');
  if (btn) { btn.disabled = !match.available; btn.innerHTML = match.available ? btn.innerHTML.replace('Sold Out','Add to Cart') : 'Sold Out'; }
}

function mmiInitScrollReveal() {
  const els = document.querySelectorAll('.reveal');
  if (!els.length || !window.IntersectionObserver) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target);} });
  }, {threshold:0.1, rootMargin:'0px 0px -40px 0px'});
  els.forEach(el => obs.observe(el));
}

document.addEventListener('shopify:section:load', () => { mmiInitScrollReveal(); });
